import axios from "@/axios";

export const getAssemblyVersion = async (): Promise<string> => {
    const response = await axios.get("/api/version");
    if (typeof response.data === "string") return response.data;
    return "";
};
